module.exports = __webpack_public_path__ + "img/pic-1.49af8277.png";